const hi = {
  demo: {
    title: `Hindi`,
  },

  Home: `होम`,
  Dashboard: `डैश्बॉर्ड`,
  description: `विवरण`,
  Description: `विवरण`,
  Details: `विवरण`,
  Book: `पुस्तक`,
  Books: `पुस्तकें`,
  Invoices: `इन्वॉइसेस`,
  Theme: `थीम`,
  Settings: `सेटिंग्स`,
  "Theme Settings": "थीम सेटिंग्स",
  Pages: `पेजेस`,
  Product: `प्राडक्ट`,
  Contacts: `कान्टैक्ट्स`,
  "Account Settings": "अकाउंट सेटिंग्स",
  More: `अधिक`,
  Profile: `प्रोफ़ाइल`,
  Logout: `लॉगआउट`,
  "Add To Cart": `कार्ट में डालें`,
  "Buy Now": `अभी खरीदें`,
  "Save Changes": `परिवर्तन सहेजें`,
  "Create Success!": `सफलतापूर्वक बनाया गया`,
  "Update Success!": `सफलतापूर्वक अपडेट किया गया`,
  "Book Name": `पुस्तक का नाम`,
  "New Book": `नई पुस्तक`,
  "Create Book": `पुस्तक बनाएं`,
  "Create a new book": `नई पुस्तक बनाएं`,
  "Edit Book": `पुस्तक संपादित करें`,
  "Regular Price": `नियमित मूल्य`,
  "Book Details": `पुस्तक का विवरण`,
  "Item for Approval": `मंजूरी के लिए आइटम`,
  "Are you sure want to approve this item?": `क्या आप वाकई इस आइटम को मंजूरी देना चाहते हैं?`,
  "First Name": `पहला नाम`,
  "Last Name": `अंतिम नाम`,
  "Email Address": `ईमेल पता`,
  "Phone Number": `फ़ोन नंबर`,
  "Please Select Country Code": `कृपया देश कोड का चयन करें`,
  "State/Region": `राज्य / क्षेत्र`,
  "Zip/Code": `ज़िप / कोड`,
  "Please Select a Role": `कृपया भूमिका का चयन करें`,
  "User: List | Minimal UI": `यूज़र: सूची | न्यूनतम यूआई`,
  "User List": `यूज़र सूची`,
  "New User": `नया यूज़र`,
  Email: `ईमेल`,
  Gender: `लिंग`,
  Country: `देश`,
  State: `राज्य`,
  City: `शहर`,
  Role: `भूमिका`,
  Company: `कंपनी`,
  Address: `पता`,
  Verified: `सत्यापित`,
  Images: `इमेजेस`,
  Save: `सहेजें`,
  Cancel: `रद्द करें`,
  Quantity: `क्वान्टटी`,
  Color: `कलर`,
  Size: `साइज़`,
  Name: `नाम`,
  Status: `स्टेटस`,
  Price: `मूल्य`,
  "Created At": `बनाया गया`,
  "Are you sure want to delete": `क्या आप वाकई हटाना चाहते हैं`,
  delete_confirmation: `क्या आप वाकई {{value1}} आइटम को हटाना चाहते हैं?`,
  approve_success: `आपकी {{value1}} पुस्तक मंजूर है`,
  "No Data": `कोई डेटा नहीं`,
  app: `एप`,
  User: `यूज़र`,
  Users: `यूज़र्स`,
  items: `आइटम्स`,
  list: `लिस्ट`,
  Add: `जोड़ें`,
  Edit: `संपादित करें`,
  Delete: `हटाएँ`,
  Share: `शेयर करना`,
  Notification: `अधिसूचना`,
  Notifications: `अधिसूचनाएं`,
  Sort: `क्रमबद्ध करें`,
  Search: `खोज`,
  Filter: `फ़िल्टर`,
  Approved: `अनुमत`,
  Approve: `मंजूरी`,
  analytics: `ऐनलिटिक`,
  ecommerce: `ई-कामर्स`,
  Management: `प्रबंध`,
  Title: `शीर्षक`,
  Date: `तारीख`,
  Time: `समय`,
  "Detail user": `विस्तृत यूज़र`,
  "Edit user": `यूज़र संपादित करें`,
  "Create a new user": `नए यूज़र बनाएं`,
  "Create User": `यूज़र बनाएं`,
  "Approve this User?": `क्या आप वाकई इस यूज़र को मंजूरी देना चाहते हैं?`,
  "Enabling this will now allow user to login.": `इसे सक्षम करने से यूज़र को लॉगिन करने की अनुमति दी जाएगी।`,
  "Activate this account?": `क्या आप वाकई इस खाते को सक्रिय करना चाहते हैं?`,
  "Disabling this will deactivate users account.": `इसे अक्षम करने से यूज़र खाता निष्क्रिय हो जाएगा।`,
  "First Name is required": `पहला नाम आवश्यक है`,
  "Email is required": `ईमेल आवश्यक है`,
  "Email must be a valid email address": `ईमेल एक मान्य ईमेल पता होना चाहिए`,
  "Phone number is required": `फ़ोन नंबर आवश्यक है`,
  "Role is required": `भूमिका आवश्यक है`,
  "Name is required": `नाम आवश्यक है`,
  "Price should not be $0.00": `मूल्य $ 0.00 नहीं होना चाहिए`,
  "Description is required": `विवरण आवश्यक है`,
};

export default hi;
